<template>
  <div>
   <!-- Navbar-->
    <!-- Remove "navbar-sticky" class to make navigation bar scrollable with the page.-->
    <header class="navbar navbar-sticky">
      <!-- Site Branding-->
      <div class="site-branding" ><a class="site-logo hidden-xs-down" href="index.html">
        <img src="static/img/logo/logo.png" alt="luxuryShop"></a><a class="site-logo logo-sm hidden-sm-up" href="index.html"><img src="static/img/logo/logo-sm.png" alt="Unishop"></a>
        <div class="lang-currency-switcher">
          <div class="lang-currency-toggle"><img src="static/img/flags/GB.png" alt="English"><span>USD</span><i class="material-icons arrow_drop_down"></i>
            <ul class="lang-currency-dropdown">
              <li>
                <select class="form-control form-control-sm">
                  <option value="usd">$ USD</option>
                  <option value="usd">€ EUR</option>
                  <option value="usd">£ UKP</option>
                  <option value="usd">¥ JPY</option>
                </select>
              </li>
              <li><a href="#"><img src="static/img/flags/FR.png" alt="Français">Français</a></li>
              <li><a href="#"><img src="static/img/flags/DE.png" alt="Deutsch">Deutsch</a></li>
              <li><a href="#"><img src="static/img/flags/IT.png" alt="Italiano">Italiano</a></li>
            </ul>
          </div>
        </div>
      </div>
      <!-- Main Navigation-->
      <nav class="site-menu">
        <ul>
          <li class="active"><a href="index.html"><span>Home</span></a>
            <ul class="sub-menu">
              <li class="active has-children"><a href="index.html"><span>Hero Slider</span></a>
                <ul class="sub-menu w-400 p-0">
                  <li><a class="p-0" href="index.html"><img src="static/img/banners/home01.jpg" alt="Hero Slider Home"></a></li>
                </ul>
              </li>
              <li class="has-children"><a href="home-featured-categories.html"><span>Categories Grid</span></a>
                <ul class="sub-menu w-400 p-0">
                  <li><a class="p-0" href="home-featured-categories.html"><img src="static/img/banners/home02.jpg" alt="Categories Grid Home"></a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li><a href="shop-boxed-ls.html"><span>Shop</span></a>
            <ul class="sub-menu">
                <li><a href="shop-categories.html">Shop Categories</a></li>
              <li class="has-children"><a href="shop-boxed-ls.html"><span>Shop Layout</span></a>
                <ul class="sub-menu">
                    <li><a href="shop-boxed-ls.html">Boxed Left Sidebar</a></li>
                    <li><a href="shop-boxed-rs.html">Boxed Right Sidebar</a></li>
                    <li><a href="shop-boxed-ft.html">Boxed Filters Top</a></li>
                    <li><a href="shop-full-ls.html">Full Width Left Sidebar</a></li>
                    <li><a href="shop-full-rs.html">Full Width Right Sidebar</a></li>
                    <li><a href="shop-full-ft.html">Full Width Filters Top</a></li>
                </ul>
              </li>
                <li><a href="shop-single.html">Single Product</a></li>
                <li><a href="cart.html">Cart</a></li>
              <li class="has-children"><a href="checkout-address.html"><span>Checkout</span></a>
                <ul class="sub-menu">
                    <li><a href="checkout-address.html">Address</a></li>
                    <li><a href="checkout-shipping.html">Shipping</a></li>
                    <li><a href="checkout-payment.html">Payment</a></li>
                    <li><a href="checkout-review.html">Review</a></li>
                    <li><a href="checkout-complete.html">Complete</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li><a href="#"><span> Mega Menu</span></a>
            <ul class="mega-menu">
              <li><span class="mega-menu-title text-uppercase">Furniture</span>
                <ul>
                  <li><a href="#">Desk &amp; Benching</a></li>
                  <li><a href="#">Adjustable Desks</a></li>
                  <li><a href="#">File Cabinets</a></li>
                  <li><a href="#">Office Chairs</a></li>
                  <li><a href="#">Tables</a></li>
                  <li><a href="#">Storage Units</a></li>
                  <li><a href="#">Accessories</a></li>
                </ul>
              </li>
              <li><span class="mega-menu-title text-uppercase">Lighting</span>
                <ul>
                  <li><a href="#">Ceiling Lights</a></li>
                  <li><a href="#">Kitchen Lighting</a></li>
                  <li><a href="#">Lamps</a></li>
                  <li><a href="#">Wall Lights</a></li>
                  <li><a href="#">Outdoor Lights</a></li>
                  <li><a href="#">Dimmers &amp; Controls</a></li>
                  <li><a href="#">Light Bulbs</a></li>
                </ul>
              </li>
              <li><span class="mega-menu-title text-uppercase">Shop by Color</span>
                <div class="widget widget-colors">
                  <ul>
                    <li><a href="#"><span class="color" style="background-color: #fff; border: 1px solid #dcdcdc;"></span>White</a></li>
                    <li><a href="#"><span class="color" style="background-color: #93c4ef;"></span>Blue</a></li>
                    <li><a href="#"><span class="color" style="background-color: #a7c04d;"></span>Green</a></li>
                    <li><a href="#"><span class="color" style="background-color: #ef0568;"></span>Red</a></li>
                    <li><a href="#"><span class="color" style="background-color: #ffce2b;"></span>Yellow</a></li>
                    <li><a href="#"><span class="color" style="background-color: #b5651d;"></span>Brown</a></li>
                  </ul>
                </div>
              </li>
              <li class="banner-column"><a href="#" style="background-image: url(static/img/banners/mega-menu.jpg);"></a></li>
            </ul>
          </li>
          <li><a href="account-orders.html"><span>Account</span></a>
            <ul class="sub-menu">
                <li><a href="account-orders.html">Orders List</a></li>
                <li><a href="account-wishlist.html">Wishlist</a></li>
                <li><a href="account-profile.html">Profile Page</a></li>
                <li><a href="account-address.html">Contact / Shipping Address</a></li>
                <li><a href="account-tickets.html">My Tickets</a></li>
                <li><a href="account-single-ticket.html">Single Ticket</a></li>
                <li><a href="account-password-recovery.html">Password Recovery</a></li>
            </ul>
          </li>
          <li><a href="blog.html"><span>Blog List</span></a>
            <ul class="sub-menu">
                <li><a href="blog.html">Blog List</a></li>
                <li><a href="blog-single.html">Single Post</a></li>
            </ul>
          </li>
          <li><a href="#"><span>Pages</span></a>
            <ul class="sub-menu">
                <li><a href="about.html">About Us</a></li>
                <li><a href="contacts.html">Contacts</a></li>
                <li><a href="faq.html">Help / FAQ</a></li>
                <li><a href="order-tracking.html">Order Tracking</a></li>
                <li><a href="404.html">404 Not Found</a></li>
                <li><a href="coming-soon.html">Coming Soon</a></li>
              <li><a class="text-danger" href="docs/dev-setup.html">Documentation</a></li>
            </ul>
          </li>
          <li><a href="components/accordion.html"><span>Components</span></a>
            <ul class="mega-menu">
              <li><span class="mega-menu-title">A - F</span>
                  <ul>
                    <li><a href="components/accordion.html">Accordion</a></li>
                    <li><a href="components/alerts.html">Alerts</a></li>
                    <li><a href="components/buttons.html">Buttons</a></li>
                    <li><a href="components/cards.html">Cards</a></li>
                    <li><a href="components/carousel.html">Carousel</a></li>
                    <li><a href="components/countdown.html">Countdown</a></li>
                    <li><a href="components/forms.html">Forms</a></li>
                  </ul>
              </li>
              <li><span class="mega-menu-title">G - M</span>
                  <ul>
                    <li><a href="components/gallery.html">Gallery</a></li>
                    <li><a href="components/google-maps.html">Google Maps</a></li>
                    <li><a href="components/images.html">Images &amp; Figures</a></li>
                    <li><a href="components/list-group.html">List Group</a></li>
                    <li><a href="components/market-social-buttons.html">Market &amp; Social Buttons</a></li>
                    <li><a href="components/media.html">Media Object</a></li>
                    <li><a href="components/modal.html">Modal</a></li>
                  </ul>
              </li>
              <li><span class="mega-menu-title">P - T</span>
                  <ul>
                    <li><a href="components/pagination.html">Pagination</a></li>
                    <li><a href="components/pills.html">Pills</a></li>
                    <li><a href="components/progress-bars.html">Progress Bars</a></li>
                    <li><a href="components/shop-items.html">Shop Items</a></li>
                    <li><a href="components/steps.html">Steps</a></li>
                    <li><a href="components/tables.html">Tables</a></li>
                    <li><a href="components/tabs.html">Tabs</a></li>
                  </ul>
              </li>
              <li><span class="mega-menu-title">T - W</span>
                  <ul>
                    <li><a href="components/team.html">Team</a></li>
                    <li><a href="components/toasts.html">Toast Notifications</a></li>
                    <li><a href="components/tooltips-popovers.html">Tooltips &amp; Popovers</a></li>
                    <li><a href="components/typography.html">Typography</a></li>
                    <li><a href="components/video-player.html">Video Player</a></li>
                    <li><a href="components/widgets.html">Widgets</a></li>
                  </ul>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <!-- Toolbar-->
      <div class="toolbar">
        <div class="inner">
          <a class="toolbar-toggle mobile-menu-toggle" href="#mobileMenu">
            <i class="material-icons menu"></i></a>
            <a class="toolbar-toggle search-toggle" href="#search">
              <i class="material-icons search"></i></a>
              <a class="toolbar-toggle" href="#account">
                <i class="material-icons person"></i></a>
                <a class="toolbar-toggle" href="#cart">
                  <i><span class="material-icons shopping_basket">
                    </span><span class="count">{{itemsInCart}}</span></i></a></div>
        <!-- Toolbar Dropdown-->
        <div class="toolbar-dropdown">
          <!-- Mobile Menu Section-->
          <div class="toolbar-section" id="mobileMenu">
            <!-- Currency / Language Siwtcher-->
            <div class="text-center mb-4">
              <div class="lang-currency-switcher">
                <div class="lang-currency-toggle"><img src="static/img/flags/GB.png" alt="English"><span>USD</span><i class="material-icons arrow_drop_down"></i>
                  <ul class="lang-currency-dropdown">
                    <li>
                      <select class="form-control form-control-sm">
                        <option value="usd">$ USD</option>
                        <option value="usd">€ EUR</option>
                        <option value="usd">£ UKP</option>
                        <option value="usd">¥ JPY</option>
                      </select>
                    </li>
                    <li><a href="#"><img src="static/img/flags/FR.png" alt="Français">Français</a></li>
                    <li><a href="#"><img src="static/img/flags/DE.png" alt="Deutsch">Deutsch</a></li>
                    <li><a href="#"><img src="static/img/flags/IT.png" alt="Italiano">Italiano</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- Search Box-->
            <form class="input-group form-group" method="get"><span class="input-group-btn">
                <button type="submit"><i class="material-icons search"></i></button></span>
              <input class="form-control" type="search" placeholder="Search website">
            </form>
            <!-- Slideable (Mobile) Menu-->
            <nav class="slideable-menu mt-4">
              <ul class="menu">
                <li class="has-children active"><span><a href="index.html"><span>Home</span></a><span class="sub-menu-toggle"></span></span>
                  <ul class="slideable-submenu">
                      <li class="active"><a href="index.html">Hero Slider</a></li>
                      <li><a href="home-featured-categories.html">Categories Grid</a></li>
                  </ul>
                </li>
                <li class="has-children"><span><a href="shop-boxed-ls.html"><span>Shop</span></a><span class="sub-menu-toggle"></span></span>
                  <ul class="slideable-submenu">
                      <li><a href="shop-categories.html">Shop Categories</a></li>
                    <li class="has-children"><span><a href="shop-boxed-ls.html"><span>Shop Layout</span></a><span class="sub-menu-toggle"></span></span>
                      <ul class="slideable-submenu">
                          <li><a href="shop-boxed-ls.html">Boxed Left Sidebar</a></li>
                          <li><a href="shop-boxed-rs.html">Boxed Right Sidebar</a></li>
                          <li><a href="shop-boxed-ft.html">Boxed Filters Top</a></li>
                          <li><a href="shop-full-ls.html">Full Width Left Sidebar</a></li>
                          <li><a href="shop-full-rs.html">Full Width Right Sidebar</a></li>
                          <li><a href="shop-full-ft.html">Full Width Filters Top</a></li>
                      </ul>
                    </li>
                      <li><a href="shop-single.html">Single Product</a></li>
                      <li><a href="cart.html">Cart</a></li>
                    <li class="has-children"><span><a href="checkout-address.html"><span>Checkout</span></a><span class="sub-menu-toggle"></span></span>
                      <ul class="slideable-submenu">
                          <li><a href="checkout-address.html">Address</a></li>
                          <li><a href="checkout-shipping.html">Shipping</a></li>
                          <li><a href="checkout-payment.html">Payment</a></li>
                          <li><a href="checkout-review.html">Review</a></li>
                          <li><a href="checkout-complete.html">Complete</a></li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li class="has-children"><span><a href="#">Categories</a><span class="sub-menu-toggle"></span></span>
                  <ul class="slideable-submenu">
                    <li class="has-children"><span><a href="#">Desks &amp; Benching</a><span class="sub-menu-toggle"></span></span>
                      <ul class="slideable-submenu">
                        <li><a href="#">Executive Desks</a></li>
                        <li><a href="#">Standing Desks</a></li>
                        <li><a href="#">Benching Desks</a></li>
                        <li><a href="#">Single Desks</a></li>
                        <li><a href="#">View All</a></li>
                      </ul>
                    </li>
                    <li class="has-children"><span><a href="#">Office Furniture</a><span class="sub-menu-toggle"></span></span>
                      <ul class="slideable-submenu">
                        <li><a href="#">File Cabinets</a></li>
                        <li><a href="#">Office Chairs</a></li>
                        <li><a href="#">Adjustable Tables</a></li>
                        <li><a href="#">Stools</a></li>
                        <li><a href="#">View All</a></li>
                      </ul>
                    </li>
                    <li class="has-children"><span><a href="#">Lounge Seating</a><span class="sub-menu-toggle"></span></span>
                      <ul class="slideable-submenu">
                        <li><a href="#">Benches</a></li>
                        <li><a href="#">Chairs</a></li>
                        <li><a href="#">Pillows</a></li>
                        <li><a href="#">Sofas</a></li>
                        <li><a href="#">View All</a></li>
                      </ul>
                    </li>
                    <li class="has-children"><span><a href="#">Storage Units</a><span class="sub-menu-toggle"></span></span>
                      <ul class="slideable-submenu">
                        <li><a href="#">Bookcases</a></li>
                        <li><a href="#">Box Seats &amp; Benches</a></li>
                        <li><a href="#">Credenza</a></li>
                        <li><a href="#">View All</a></li>
                      </ul>
                    </li>
                    <li class="has-children"><span><a href="#">Lighting</a><span class="sub-menu-toggle"></span></span>
                      <ul class="slideable-submenu">
                        <li><a href="#">Ceiling Lights</a></li>
                        <li><a href="#">Kitchen Lights</a></li>
                        <li><a href="#">Wall Lights</a></li>
                        <li><a href="#">Lamps</a></li>
                        <li><a href="#">View All</a></li>
                      </ul>
                    </li>
                    <li class="has-children"><span><a href="#">Furniture Accessories</a><span class="sub-menu-toggle"></span></span>
                      <ul class="slideable-submenu">
                        <li><a href="#">Power Management</a></li>
                        <li><a href="#">Desk Add Ons</a></li>
                        <li><a href="#">Lamps</a></li>
                        <li><a href="#">Monitor Arms</a></li>
                        <li><a href="#">Desk Risers</a></li>
                        <li><a href="#">View All</a></li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li class="has-children"><span><a href="account-orders.html"><span>Account</span></a><span class="sub-menu-toggle"></span></span>
                  <ul class="slideable-submenu">
                      <li><a href="account-orders.html">Orders List</a></li>
                      <li><a href="account-wishlist.html">Wishlist</a></li>
                      <li><a href="account-profile.html">Profile Page</a></li>
                      <li><a href="account-address.html">Contact / Shipping Address</a></li>
                      <li><a href="account-open-ticket.html">Open Ticket</a></li>
                      <li><a href="account-tickets.html">My Tickets</a></li>
                      <li><a href="account-single-ticket.html">Single Ticket</a></li>
                      <li><a href="account-password-recovery.html">Password Recovery</a></li>
                  </ul>
                </li>
                <li class="has-children"><span><a href="blog.html"><span>Blog List</span></a><span class="sub-menu-toggle"></span></span>
                  <ul class="slideable-submenu">
                      <li><a href="blog.html">Blog List</a></li>
                      <li><a href="blog-single.html">Single Post</a></li>
                  </ul>
                </li>
                <li class="has-children"><span><a href="#">Pages</a><span class="sub-menu-toggle"></span></span>
                  <ul class="slideable-submenu">
                      <li><a href="about.html">About Us</a></li>
                      <li><a href="contacts.html">Contacts</a></li>
                      <li><a href="faq.html">Help / FAQ</a></li>
                      <li><a href="order-tracking.html">Order Tracking</a></li>
                      <li><a href="404.html">404 Not Found</a></li>
                      <li><a href="coming-soon.html">Coming Soon</a></li>
                    <li><a class="text-danger" href="docs/dev-setup.html">Documentation</a></li>
                  </ul>
                </li>
                <li class="has-children"><span><a href="components/accordion.html"><span>Components</span></a><span class="sub-menu-toggle"></span></span>
                  <ul class="slideable-submenu">
                      <li><a href="components/accordion.html">Accordion</a></li>
                      <li><a href="components/alerts.html">Alerts</a></li>
                      <li><a href="components/buttons.html">Buttons</a></li>
                      <li><a href="components/cards.html">Cards</a></li>
                      <li><a href="components/carousel.html">Carousel</a></li>
                      <li><a href="components/countdown.html">Countdown</a></li>
                      <li><a href="components/forms.html">Forms</a></li>
                      <li><a href="components/gallery.html">Gallery</a></li>
                      <li><a href="components/google-maps.html">Google Maps</a></li>
                      <li><a href="components/images.html">Images &amp; Figures</a></li>
                      <li><a href="components/list-group.html">List Group</a></li>
                      <li><a href="components/market-social-buttons.html">Market &amp; Social Buttons</a></li>
                      <li><a href="components/media.html">Media Object</a></li>
                      <li><a href="components/modal.html">Modal</a></li>
                      <li><a href="components/pagination.html">Pagination</a></li>
                      <li><a href="components/pills.html">Pills</a></li>
                      <li><a href="components/progress-bars.html">Progress Bars</a></li>
                      <li><a href="components/shop-items.html">Shop Items</a></li>
                      <li><a href="components/steps.html">Steps</a></li>
                      <li><a href="components/tables.html">Tables</a></li>
                      <li><a href="components/tabs.html">Tabs</a></li>
                      <li><a href="components/team.html">Team</a></li>
                      <li><a href="components/toasts.html">Toast Notifications</a></li>
                      <li><a href="components/tooltips-popovers.html">Tooltips &amp; Popovers</a></li>
                      <li><a href="components/typography.html">Typography</a></li>
                      <li><a href="components/video-player.html">Video Player</a></li>
                      <li><a href="components/widgets.html">Widgets</a></li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
          <!-- Search Section-->
          <div class="toolbar-section" id="search">
            <form class="search-form mb-2" method="get">
              <input type="search" placeholder="Type search query"><i class="material-icons search"></i>
            </form>
            <!-- Products-->
            <div class="widget widget-featured-products">
              <h3 class="widget-title">Found in Products</h3>
              <!-- Entry-->
              <div class="entry">
                <div class="entry-thumb"><a href="shop-single.html"><img src="static/img/shop/widget/01.png" alt="Product"></a></div>
                <div class="entry-content">
                  <h4 class="entry-title"><a href="shop-single.html">Max <span class='text-highlighted'>Task Chair</span></a></h4><span class="entry-meta">$299.00</span>
                </div>
              </div>
              <!-- Entry-->
              <div class="entry">
                <div class="entry-thumb"><a href="shop-single.html"><img src="static/img/shop/widget/02.png" alt="Product"></a></div>
                <div class="entry-content">
                  <h4 class="entry-title"><a href="shop-single.html"><span class='text-highlighted'>Drawer</span> File Cabinet</a></h4><span class="entry-meta">$265.00</span>
                </div>
              </div>
              <!-- Entry-->
              <div class="entry">
                <div class="entry-thumb"><a href="shop-single.html"><img src="static/img/shop/widget/03.png" alt="Product"></a></div>
                <div class="entry-content">
                  <h4 class="entry-title"><a href="shop-single.html">Campfire <span class='text-highlighted'>Paper</span> Table</a></h4><span class="entry-meta">$570.00</span>
                </div>
              </div>
            </div>
            <!-- Blog-->
            <div class="widget widget-featured-products">
              <h3 class="widget-title">Found in Blog</h3>
              <!-- Entry-->
              <div class="entry">
                <div class="entry-thumb"><a href="blog-single.html"><img src="static/img/blog/widget/01.jpg" alt="Post"></a></div>
                <div class="entry-content">
                  <h4 class="entry-title"><a href="blog-single.html"><span class='text-highlighted'>Modern</span> Working Space</a></h4><span class="entry-meta">May 09</span>
                </div>
              </div>
              <!-- Entry-->
              <div class="entry">
                <div class="entry-thumb"><a href="blog-single.html"><img src="static/img/blog/widget/02.jpg" alt="Post"></a></div>
                <div class="entry-content">
                  <h4 class="entry-title"><a href="blog-single.html">Interior <span class='text-highlighted'>Design</span> Tricks</a></h4><span class="entry-meta">April 18</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Account Section-->
          <div class="toolbar-section" id="account">
            <ul class="nav nav-tabs nav-justified" role="tablist">
              <li class="nav-item"><a class="nav-link active" href="#login" data-toggle="tab" role="tab">Log In</a></li>
              <li class="nav-item"><a class="nav-link" href="#signup" data-toggle="tab" role="tab">Sign Up</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane fade show active" id="login" role="tabpanel">
                <form autocomplete="off" id="login-form">
                  <div class="form-group input-group">
                    <input class="form-control" type="email" placeholder="Email" required><span class="input-group-addon"><i class="material-icons mail"></i></span>
                  </div>
                  <div class="form-group input-group">
                    <input class="form-control" type="password" placeholder="Password" required><span class="input-group-addon"><i class="material-icons lock"></i></span>
                  </div>
                  <div class="custom-control custom-checkbox form-group">
                    <input class="custom-control-input" type="checkbox" id="logged" checked>
                    <label class="custom-control-label" for="logged">Keep me logged in</label>
                  </div>
                  <button class="btn btn-primary btn-block" type="submit">Log In</button>
                </form>
              </div>
              <div class="tab-pane fade" id="signup" role="tabpanel">
                <form autocomplete="off" id="signup-form">
                  <div class="form-group">
                    <input class="form-control" type="text" placeholder="Full Name" required>
                  </div>
                  <div class="form-group">
                    <input class="form-control" type="email" placeholder="Email" required>
                  </div>
                  <div class="form-group">
                    <input class="form-control" type="password" placeholder="Password" required>
                  </div>
                  <div class="form-group">
                    <input class="form-control" type="password" placeholder="Confirm Password" required>
                  </div>
                  <button class="btn btn-primary btn-block" type="submit">Sign Up</button>
                  <p class="text-muted text-sm mt-4">OR sign up with your social account</p><a class="media-btn media-facebook" href="#"><i class="socicon-facebook"></i><span>Signup with Facebook</span></a><a class="media-btn media-google" href="#"><i class="socicon-googleplus"></i><span>Signup with Google+</span></a><a class="media-btn media-twitter" href="#"><i class="socicon-twitter"></i><span>Signup with Twitter</span></a>
                </form>
              </div>
            </div>
          </div>
          <!-- Shopping Cart Section-->
          <div class="toolbar-section" id="cart">
            <div class="table-responsive shopping-cart mb-0">
              <table class="table">
                <thead>
                  <tr>
                    <th colspan="2">
                      <div class="d-flex justify-content-between align-items-center">Produits
                        <router-link class="navi-link text-uppercase" to="/cart">
                          <span class="text-xxs">Votre panier</span>
                          <i class="material-icons keyboard_arrow_right"></i>
                        </router-link>
                          </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product in products" v-bind:key="product.id">
                    <td>
                      <div class="product-item"><a class="product-thumb" href="shop-single.html">
                        <img :src="product.img" alt="Product"></a>
                        <div class="product-info">
                          <h4 class="product-title"><a href="shop-single.html">{{product.name}}</a>
                          </h4><span><em>Prix:</em> {{product.price}}</span><span><em>Quantité:</em> {{product.quantity}}</span>
                        </div>
                      </div>
                    </td>
                    <td class="text-center"><a class="remove-from-cart" href="#" @click="removeItem(product)"><i class="material-icons icon_close"></i></a></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr class="mb-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
              <div class="pr-2 py-1 text-sm">Total: <span class='text-dark text-medium'>{{total}}</span></div>
              <router-link class="btn btn-sm btn-success mb-0 mr-0" to="/checkout">Commander</router-link>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  computed: {
    products() {
      return this.$store.getters.cartProducts;
    },
    itemsInCart() {
      let cart = this.$store.getters.cartProducts;
      return cart.reduce((accum, item) => accum + item.quantity, 0);
    },
    total() {
      return this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
    }
  },
  methods: mapActions(['removeItem'])
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue